module.exports = {versao:  913 ,
old:false,
parceria:true,
url:"https://api.untaxi.com.br/"};
